import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-Icon3dPackage"><Path d="M11 12.5771V22.5762L2.33984 17.5771V7.57715L11 12.5771Z" fill="currentColor"/><Path d="M21.6602 17.5771L13 22.5762V12.5771L21.6602 7.57715V17.5771Z" fill="currentColor"/><Path d="M15.3291 8.92188L12 10.8447L3.33984 5.84473L6.66895 3.92285L15.3291 8.92188Z" fill="currentColor"/><Path d="M20.6592 5.84473L17.3281 7.76758L8.66895 2.76758L12 0.845703L20.6592 5.84473Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon3dPackage;
